module.exports = __webpack_public_path__ + "static/media/error.3b7f0b12.svg";